import randomColor from "randomcolor";

export function calculateRandomColorFromSeed(seed: string, hue?: number | string | undefined) {
  return randomColor({ hue, seed });
}
